import React from 'react';
import { Link } from 'react-router-dom';

const Blog = () => {
  const blogPosts = [
    {
      title: "The Evolution of AI Models in 2024",
      path: "/blog/first-post",
      author: "AI Enthusiast",
      date: "March 15, 2024",
      summary: "Exploring the latest developments in AI models and their impact on various industries."
    },
    {
      title: "Understanding Model Pricing and Efficiency",
      path: "/blog/second-post",
      author: "Tech Analyst",
      date: "March 10, 2024",
      summary: "A deep dive into AI model pricing structures and how to optimize for efficiency."
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8 bg-[#121212] min-h-screen">
      <h1 className="text-4xl font-bold text-white mb-8 text-center">
        AI Model Insights Blog
      </h1>
      <div className="max-w-3xl mx-auto">
        {blogPosts.map((post, index) => (
          <div 
            key={index} 
            className="bg-[#1e1e1e] rounded-lg shadow-md p-6 mb-6 hover:shadow-xl transition-shadow border border-gray-800"
          >
            <Link to={post.path} className="block">
              <h2 className="text-2xl font-bold text-[#90caf9] mb-2 hover:text-blue-400 transition-colors">
                {post.title}
              </h2>
            </Link>
            <div className="text-sm text-gray-400 mb-3">
              <span>{post.author}</span>
              <span className="mx-2">•</span>
              <span>{post.date}</span>
            </div>
            <p className="text-gray-300 mb-4">
              {post.summary}
            </p>
            <Link 
              to={post.path}
              className="text-[#90caf9] hover:text-blue-400 font-medium inline-flex items-center group transition-colors"
            >
              Read more
              <span className="ml-1 text-sm group-hover:translate-x-1 transition-transform">→</span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog; 